<template>
  <div class="box">
    <van-nav-bar
      class="nav_bar"
      left-arrow
      right-arrow
      @click-left="backToLast"
    >
      <template #left>
        <img
          style="width: 18.44px; height: 17.35px"
          src="@/assets/home/white_back.png"
        />
      </template>
      <template #right>
        <img
          class="shareImg"
          src="@/assets/home/product_detail/share_icon.png"
          @click="shareClick"
        />
      </template>
    </van-nav-bar>
    <!-- <img class="topImg" src="" /> -->
    <div class="header-box">
      <van-swipe class="topImg" :autoplay="3000">
        <van-swipe-item v-for="(image, index) in bannerImages" :key="index">
          <img class="topImg_img" :src="getFilePath(image.filePath)" />
        </van-swipe-item>
      </van-swipe>
      <market-skill-info-bar :activityInfo="seckillActivityInfo">
      </market-skill-info-bar>
    </div>

    <div class="topInfo">
      <div class="toptitle">
        <span class="flex1">{{ goodInfo.productName }}</span>
        <span
          v-if="isShowGetCoupon"
          class="coupons-text"
          @click="showCouponCardClick"
          >领取优惠券</span
        >
      </div>
      <div class="price-box">
        <div class="topPrice">
          ¥<span>{{ goodInfo.minPrice }}</span
          ><span>起</span>
        </div>
        <div v-if="goodInfo.relationProductId" class="remark">云仓</div>
      </div>
    </div>
    <div class="centerInfo">
      <div class="type_box" @click="selectInfo">
        <div class="types">
          <div class="typeLabel">规格</div>
          <div class="typeValue">{{ typeValue }}</div>
        </div>
        <img
          style="width: 12px; height: 13px"
          src="@/assets/order/gray_right_icon.png"
        />
      </div>
      <div v-if="goodInfo.isVirtualProduct !== '1'">
        <div v-if="goodInfo.isSelfProvided == '1'" class="isSelfProvider-box">
          <div class="typeLabel">发货</div>
          <div class="isSelfProviderName">自提</div>
          <div class="isSelfProviderAddress">
            {{ goodInfo.selfProvidedAddress || "" }}
          </div>
        </div>
        <div v-else class="type_box_1">
          <div class="typeLabel">发货</div>
          <div class="typeValue">{{ sendCity }}</div>
          <!-- <div class="typeValue">{{ fastFareType }}</div> -->
        </div>
      </div>
    </div>

    <div class="active-product-box" v-if="seckillActivityInfos.length">
      <common-title title="商品秒杀" :hiddenBottomLine="true"></common-title>
      <div class="active-product-item">
        <div
          class="active-product-item-cell"
          v-for="(item, index) in seckillActivityInfos"
          :key="index + 'r'"
        >
          <div class="active-product-name-box">
            <div class="active-product-name">
              {{ goodInfo.productName }}
            </div>
            <div class="orderBtn" @click="toActiveOrder(item)">
              秒杀
            </div>
          </div>
          <div class="active-product-price-box">
            <div class="active-product-active-price">
              最低活动价：¥{{ item.activityPrice }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="active-product-box" v-if="regimentActivityInfos.length">
      <common-title title="商品拼团" :hiddenBottomLine="true"></common-title>
      <div class="active-product-item">
        <div
          class="active-product-item-cell"
          v-for="(item, index) in regimentActivityInfos"
          :key="index + 'r'"
        >
          <div class="active-product-name-box">
            <div class="active-product-name">
              {{ goodInfo.productName }}
            </div>
            <div class="orderBtn" @click="regimentOrder(item)">
              拼团
            </div>
          </div>
          <div class="active-product-price-box">
            <div class="active-product-active-price">
              最低活动价：¥{{ item.activityPrice }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="active-product-box" v-if="bargainActivityInfos.length">
      <common-title title="商品砍价" :hiddenBottomLine="true"></common-title>
      <div class="active-product-item">
        <div
          class="active-product-item-cell"
          v-for="(item, index) in bargainActivityInfos"
          :key="index + 'b'"
        >
          <div class="active-product-name-box">
            <div class="active-product-name">
              {{ goodInfo.productName }}
            </div>
            <div class="orderBtn" @click="toActiveOrder(item)">
              砍价
            </div>
          </div>
          <div class="active-product-price-box">
            <div class="active-product-active-price">
              活动价：¥{{ item.activityPrice }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-tabs class="detail_content_box" scrollspy sticky>
      <van-tab title="商品介绍">
        <common-title title="商品介绍" :hiddenBottomLine="true"></common-title>
        <div class="construct">{{ goodInfo.productDesc }}</div>
      </van-tab>
      <van-tab title="商品详情">
        <common-title title="商品详情" :hiddenBottomLine="true"></common-title>
        <div class="construct" v-html="getProductDetail"></div>
      </van-tab>
      <van-tab title="包装售后">
        <common-title title="包装售后" :hiddenBottomLine="true"></common-title>
        <div class="construct" v-html="getProductPackage"></div>
      </van-tab>
      <van-tab title="说明">
        <common-title title="说明" :hiddenBottomLine="true"></common-title>
        <div class="construct">{{ goodInfo.productMsg }}</div>
      </van-tab>
      <van-tab title="点评">
        <ticket-comment-info
          :data="comments"
          @toAllComment="toAllComment"
        ></ticket-comment-info>
      </van-tab>
    </van-tabs>
    <div class="whiteSpace"></div>
    <div class="bottom_buttons">
      <div class="sharePrice"><span>¥</span>{{ contentPrice.toFixed(2) }}</div>
      <div
        class="addCart"
        v-if="goodInfo.isSelfProvided != '1' && !goodInfo.relationProductId"
        @click="toOrder(0)"
      >
        加入购物车
      </div>
      <div
        class="placeOrder"
        :style="{
          opacity: requestCode == 802 || requestCode == 805 ? '0.5' : '1.0',
        }"
        @click="toOrder(1)"
      >
        {{ outBuyBtn }}
      </div>
    </div>
    <van-popup
      v-model="show"
      round
      closeable
      close-icon="close"
      position="bottom"
      :close-on-click-overlay="false"
      :style="{ height: '70%' }"
      @close="closePopup"
    >
      <div class="content_box">
        <div class="content_top">
          <img class="content_img" :src="getFilePath(inImg.filePath)" />
          <div class="name_price">
            <div class="productName">
              {{ goodInfo.productName }}
            </div>
            <div class="content_price">
              ¥<span>{{
                showSeckill && selectActive.mainType === "seckill"
                  ? selectActive.activityPrice
                  : basePrice
              }}</span>
            </div>
          </div>
        </div>
        <div class="contentTypeText">规格</div>
        <div class="content_body">
          <div class="contentTypeBox">
            <div
              class="contentTypeItem"
              v-for="(item, index) in goodsList"
              :key="index"
              @click="selectGooditem(index)"
              :class="{ activeGoods: currentSelect == index }"
            >
              {{ item.goodsSpecName }}
            </div>
          </div>

          <div class="contentNums">
            <div class="numsLeft">
              <div class="numText">购买数量</div>
              <div class="leftNum">库存 {{ currentInventory }} 件</div>
            </div>
            <div class="nums_box">
              <img
                class="nums_reduce"
                src="@/assets/order/reduce_icon.png"
                @click="reduceNum"
              />
              <span class="nums_num">{{ nums }}</span>
              <img
                class="nums_reduce"
                src="@/assets/order/add_icon.png"
                @click="addNum"
              />
            </div>
          </div>
        </div>

        <div class="buttons">
          <div
            class="addshippingCart"
            :style="{
              opacity: currentInventory == 0 ? '0.5' : '1.0',
            }"
            @click="toShippingCart"
            v-if="
              !showSeckill &&
                goodInfo.isSelfProvided != '1' &&
                !goodInfo.relationProductId
            "
          >
            加入购物车
          </div>
          <div
            class="toBuy"
            :style="{
              opacity:
                currentInventory == 0 ||
                requestCode == 802 ||
                requestCode == 805
                  ? '0.5'
                  : '1.0',
            }"
            @click="toBuy"
          >
            {{ buyBtn }}
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="showCouponCard"
      closeable
      title="领取优惠券"
      position="bottom"
      :style="{ height: '440px' }"
    >
      <coupons-card
        :type="3"
        :productList="[productId]"
        productType="4"
      ></coupons-card>
    </van-popup>

    <van-overlay :show="showShare" z-index="99" @click="clickOverlay">
      <div class="poster_wrapper_box" @click.stop>
        <div class="block_box">
          <product-poster-optimize
            v-if="showShare"
            :coverImage="sharePosterInfoComputed.coverImage"
            :productName="sharePosterInfoComputed.productName"
            :des="sharePosterInfoComputed.des"
            :price="sharePosterInfoComputed.price"
          ></product-poster-optimize>
        </div>
      </div>
    </van-overlay>
    <!-- <van-overlay :show="showShare" z-index="99" @click="clickOverlay" /> -->
    <suspension-button></suspension-button>
    <div class="add-paycar" @click="addPaycar">
      <img src="../../../assets/add-car.png" alt="" />
    </div>
  </div>
</template>

<script>
import {
  weChatUpdateAppMessageShareData,
  weChatUpdateTimelineShareData,
} from "@/lib/weixin-js-sdk";
import { getUserQfRegisterInfo } from '@/api/user';
import commonTitle from "../../../components/common_title.vue";
import ticketCommentInfo from "@/components/ticket_comment_info.vue";
import { getImgUrl } from "@/mixins/getImgUrl";
import couponsCard from "../../../components/coupons-card.vue";
import marketSkillInfoBar from "@/components/market-skill-info-bar.vue";
import suspensionButton from "@/components/suspension-button.vue";
import productPosterOptimize from '@/new_views/activity/product-poster-optimize';
export default {
  components: {
    commonTitle,
    ticketCommentInfo,
    couponsCard,
    marketSkillInfoBar,
    suspensionButton,
    productPosterOptimize
  },
  mixins: [getImgUrl],
  data() {
    return {
      productId: "",
      goodInfo: {},
      goodsList: [],
      bannerImages: [],
      commentList: [],
      typeValue: "请选择",
      fastFareType: "", // 发货方式
      sendCity: "", //发货城市
      show: false,
      contentPrice: 0,
      nums: 1,
      currentSelect: 0,
      currentInventory: 0,
      basePrice: 0,
      inImg: {},
      comments: {},
      params: {},
      showCouponCard: false, // 优惠券弹窗
      couponCardKey: 1, // 每次显示都重新获取
      showShare: false, // 分享海报
      showMinPrice: false,
      seckillActivityInfo: null, // 秒杀活动
      seckillActivityInfos: [], // 秒杀活动
      selectActive: null, // 临时选中的活动
      regimentActivityInfos: [], // 平团活动
      bargainActivityInfos: [], // 砍价活动
      showSeckill: false, //活动下单规格
      marketType: 4,
      requestCode: 0, //请求code
      isShowGetCoupon: false,
    };
  },
  computed: {
    buyBtn() {
      return this.showSeckill ? "活动下单" : "立即购买";
    },
    outBuyBtn() {
      if (this.requestCode == 802) {
        return "产品已下架";
      } else if (this.requestCode == 805) {
        return "产品无库存";
      } else {
        return "立即购买";
      }
    },
    // 分享的海报数据
    sharePosterInfoComputed() {
      const coverImage = this.getCoverImage();
      let shareInfo = {
        coverImage: coverImage,
        productName: this.goodInfo.productName,
        des: this.goodInfo.productDesc,
        price: this.goodInfo.minPrice,
      };
      return shareInfo;
    },
    getProductDetail() {
      return this.goodInfo.productDetail?.replace(
        /<img/g,
        "<img style='max-width: 100%; height:auto;'"
      );
    },
    getProductPackage() {
      return this.goodInfo.productPackage?.replace(
        /<img/g,
        "<img style='max-width: 100%; height:auto;'"
      );
    },
  },
  mounted() {
    this.productId = this.$route.query.ID;
    // 营销进来的标识
    this.marketType = parseInt(this.$route.query.marketType) || 4;
    this.init();
  },
  methods: {
    toOrder(index) {
      if (this.requestCode == 802 || this.requestCode == 805) {
        return;
      }
      this.show = true;
      // if (this.typeValue == "请选择") {
      //   if (this.goodsList.length === 1) {
      //     this.typeValue = this.goodsList[0].goodsSpecName;
      //   } else {
      //     this.showSeckill = false;
      //     this.show = true;
      //     return false;
      //   }
      // }
      // switch (index) {
      //   case 0: //加入购物车
      //     this.toShippingCart();
      //     break;

      //   default:
      //     //预定
      //     this.toBuy();
      //     break;
      // }
    },
    toActiveOrder(e) {
      this.selectActive = e;
      if (this.typeValue == "请选择") {
        this.showSeckill = true;
        this.selectGooditem(0);
        this.show = true;
        return false;
      }
      this.toBuy();
    },
    // 拼团下单
    regimentOrder(e) {
      this.$router.push({
        path: "/group-buy-detail",
        query: {
          mainId: e.mainId,
        },
      });
    },

    closePopup() {
      this.typeValue = this.goodsList[this.currentSelect].goodsSpecName;
    },
    init() {
      const toast = this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: "加载中...",
      });
      var params = {
        originType: "1",
        resourceId: this.productId,
      };
      this.$API.z_product
        .goodsDetail(params, this.$route.query.ID)
        .then((res) => {
          toast.clear();
          this.requestCode = res.code;
          if (res.code == 200) {
            this.goodInfo = res.data.goodsInfo;
            this.showMinPrice =
              this.goodInfo.maxPrice != this.goodInfo.minPrice;

            this.bannerImages = this.goodInfo.pictures;
            this.inImg = this.bannerImages[0];

            this.goodsList = res.data.goodsList;
            this.fastFareType =
              this.goodInfo.fastFareType == "1"
                ? "包邮"
                : this.goodInfo.fastFareType == "2"
                ? "运费模板"
                : "统一运费";
            this.selectGooditem(0);

            this.configureShareInfo();
            this.calculatePrice();
            this.requestComments();
            // 遍历商品秒杀活动
            this.requestSkillActive();
            //获取订购产品信息
            this.getBuyProductInfoBuyId();
            this.selectProductCouponsList();
          }
        })
        .catch((res) => {
          toast.clear();
          this.requestCode = res.code;
          if (res.code == 802 || res.code == 805) {
            this.goodInfo = res.data.goodsInfo;
            this.showMinPrice =
              this.goodInfo.maxPrice != this.goodInfo.minPrice;

            this.bannerImages = this.goodInfo.pictures;
            this.inImg = this.bannerImages[0];

            this.goodsList = res.data.goodsList;
            this.fastFareType =
              this.goodInfo.fastFareType == "1"
                ? "包邮"
                : this.goodInfo.fastFareType == "2"
                ? "运费模板"
                : "统一运费";
            this.selectGooditem(0);

            this.configureShareInfo();
            this.calculatePrice();
            this.requestComments();
            // 遍历商品秒杀活动
            this.requestSkillActive();
            //获取订购产品信息
            this.getBuyProductInfoBuyId();
            this.selectProductCouponsList();
          }
        });
    },

    getBuyProductInfoBuyId() {
      this.$API.z_product
        .getBuyProductInfoBuyId(this.goodInfo.productId)
        .then((res) => {
          this.sendCity =
            res.data.productGood.sendCity +
            (res.data.basicFreight == 0
              ? ""
              : "  运费：" + res.data.basicFreight + "元");
        });
    },
    // 产品的优惠券列表
    selectProductCouponsList() {
      var param = {
        productIds: [this.productId],
        productType: "4",
        receiveChannel: "h5",
      };
      this.$API.coupons
        .selectProductCouponsList(param)
        .then((res) => {
          if (res.data && res.data.length > 0) {
            this.isShowGetCoupon = true;
          } else {
            this.isShowGetCoupon = false;
          }
        })
        .catch((err) => {
          this.isShowGetCoupon = false;
        });
    },

    // 遍历商品秒杀活动
    requestSkillActive() {
      const data = [this.productId];
      this.$API.market
        .getProductActiveDetail(data)
        .then((res) => {
          var seckillActivityInfoList = res.data.filter((res) => {
            return res.mainType === "seckill";
          });
          if (seckillActivityInfoList.length) {
            this.seckillActivityInfo = seckillActivityInfoList[0];
            this.seckillActivityInfos = seckillActivityInfoList;
          }

          var regimentActivityInfoList = res.data.filter((res) => {
            return res.mainType === "regiment";
          });
          if (regimentActivityInfoList.length) {
            this.regimentActivityInfos = regimentActivityInfoList;
          }

          var bargainActivityInfos = res.data.filter((res) => {
            return res.mainType === "bargain";
          });
          if (bargainActivityInfos.length) {
            this.bargainActivityInfos = bargainActivityInfos;
          }
        })
        .catch((err) => {});
    },

    backToLast() {
      this.$router.go(-1);
    },
    toShare() {},
    selectInfo() {
      this.showSeckill = false;
      this.show = true;
    },
    selectGooditem(index) {
      this.currentSelect = index;
      this.currentInventory = this.goodsList[index].currentInventory || 0;
      // 活动价格
      if (this.$store.getters.identityDeal) {
        this.basePrice = this.goodsList[index].dealPrice;
      } else {
        this.basePrice = this.goodsList[index].distributionPrice;
      }

      this.nums = 1;
      this.calculatePrice();
    },
    reduceNum() {
      if (this.showSeckill) {
        return;
      }
      if (this.nums > 1) {
        this.nums = this.nums - 1;
        // this.customerInfoList.splice(this.customerInfoList.length - 1, 1);
        // this.calculatePrice();
        this.calculatePrice();
      } else {
        return false;
      }
    },
    addNum() {
      if (this.showSeckill) {
        return;
      }
      if (this.currentInventory <= this.nums) {
        return;
      }
      this.nums = this.nums + 1;
      this.calculatePrice();
    },
    calculatePrice() {
      this.contentPrice = this.nums * this.basePrice;
    },
    toShippingCart() {
      if (
        this.goodInfo.relationProductId &&
        this.goodInfo.relationProductId.length > 0
      ) {
        return;
      }
      if (
        this.currentInventory == 0 ||
        this.requestCode == 802 ||
        this.requestCode == 805
      ) {
        return false;
      }
      var params = {
        currentInventory: this.currentInventory,
        endPrice: this.basePrice,
        filePath: this.inImg.filePath,
        goodsId: this.goodsList[this.currentSelect].id,
        goodsName: this.goodsList[this.currentSelect].goodsSpecName,
        orderQuantity: this.nums,
        productId: this.goodInfo.productId,
        productName: this.goodInfo.productName,
      };
      this.$API.z_product.addGoodsCart(params).then((res) => {
        if (res.code == 200) {
          this.$toast("加入购物车成功！");
        }
      });
    },
    toBuy() {
      if (
        this.currentInventory == 0 ||
        this.requestCode == 802 ||
        this.requestCode == 805
      ) {
        return false;
      }
      localStorage.removeItem("addressInfo");
      let filePath = this.inImg.filePath;
      let goods = {
        fastFareType: this.goodInfo.fastFareType,
        fixedFreight: this.goodInfo.fixedFreight,
        id: this.goodInfo.productId,
        isSelfProvided: this.goodInfo.isSelfProvided,
        productName: this.goodInfo.productName,
        selfProvidedAddress: "",
        tempId: this.goodInfo.tempId,
        relationProductId: this.goodInfo.relationProductId,
      };
      let orderGoodsDetailList = {
        distributionPrice: this.basePrice,
        marketPrice: this.basePrice,
        goodsId: this.goodsList[this.currentSelect].id,
        orderQuantity: this.nums,
        specName: this.goodsList[this.currentSelect].goodsSpecName,
      };
      let goodsDetails = [
        {
          filePath: filePath,
          goods: goods,
          orderGoodsDetailList: [orderGoodsDetailList],
        },
      ];
      this.$router.push({
        path: "/order/goods_place_order",
        query: {
          goodsDetails: JSON.stringify(goodsDetails),
          activityInfo: this.showSeckill
            ? JSON.stringify(this.selectActive)
            : null,
        },
      });
    },
    requestComments() {
      var arr = [];
      if (this.goodsList.length > 0) {
        for (let index = 0; index < this.goodsList.length; index++) {
          const e = this.goodsList[index];
          arr.push(e.productId);
        }
      }

      this.params = {
        organizationId: this.$store.state.orgId,
        pageSize: 1,
        currentPage: 1,
      };
      if (arr.length > 0) {
        this.params.productId = arr;
      }
      this.$API.z_product.queryCommentPage(this.params).then((res) => {
        if (res.code == 0) {
          this.comments = res.data;
          this.commentList = this.comments.commentPageInfo;
        }
      });
    },
    toAllComment() {
      this.$router.push({
        path: "/order/orderComment",
        query: { data: this.params },
      });
    },
    // 配置分享数据
    configureShareInfo() {
      // 微信分享  自定义“分享给朋友”及“分享到QQ”按钮的分享内容
      const coverImg = this.getCoverImage();
      weChatUpdateAppMessageShareData({
        title: this.goodInfo.productName, // 分享标题
        desc: "", // 分享描述
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: this.getFilePath(coverImg), // 分享图标
        success: () => {
          // 设置成功
        },
      });

      // 微信分享 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
      weChatUpdateTimelineShareData({
        title: this.goodInfo.productName, // 分享标题
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: this.getFilePath(coverImg), // 分享图标
        success: () => {
          // 设置成功
        },
      });
    },

    addPaycar() {
      this.$router.push({ path: "/order/shippingCart" });
    },
    getCoverImage() {
      const data = this.bannerImages
        .filter((res) => {
          return res.isPoster === "Y";
        })
        .map((res) => {
          return res.filePath;
        });
      return data[0] || this.bannerImages[0]?.filePath;
    },
    // 点击分享
    async shareClick() {
      const res = await getUserQfRegisterInfo();
      if (res.code === 200) {
        // 如果未认证需要先认证
        if (res.data.authFlag == 0 && res.data.userType != 3) {
          this.$router.push('/userRegisterBefore')
        } else {
          // 不滚动到最上面，会出现生成的图片上部空白的情况
          document.body.scrollTo({
            top: 0,
          });
          // 兼容写法，两个都必须要
          document.documentElement.scrollTo({
            top: 0,
          });
          document.body.style.overflow = "hidden";
          this.showShare = true;
          this.shareLog();
        }
      }
    },
    shareLog() {
      const userId = this.$store.state.userInfo_v2.user.userId;
      const openId = localStorage.getItem("openId");
      const data = {
        shareId: this.productId,
        openGid: openId,
        userId: userId,
      };
      this.$API.market.shareLog(data).then((res) => {});
    },
    // 点击分享遮罩层
    clickOverlay() {
      this.showShare = false;
      document.body.style.overflow = "auto";
    },
    // 显示优惠券
    showCouponCardClick() {
      this.showCouponCard = true;
      this.couponCardKey++;
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  background-color: #f4f6f9;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
  padding-bottom: vw(100);
  // 去掉导航栏底部的一根细线
  .van-hairline--bottom:after {
    border-bottom-width: 0px;
  }
  .nav_bar {
    position: absolute;
    z-index: 9;
    top: 0;
    left: 0;
    right: 0;
    background-color: rgba($color: #fff, $alpha: 0);
  }
  .likeImg {
    width: vw(40);
    height: vw(36);
    margin-right: vw(50);
  }
  .shareImg {
    width: vw(49);
    height: vw(49);
  }

  .header-box {
    position: relative;
    .topImg {
      width: 100%;
      height: vw(400);
      background-color: gray;
      .topImg_img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .topInfo {
    position: relative;
    margin-top: vw(-20);
    border-top-left-radius: vw(20);
    border-top-right-radius: vw(20);
    background-color: #ffffff;
    padding-top: vw(20);
    padding-bottom: vw(20);
    .toptitle {
      display: flex;
      align-items: flex-start;
      margin-left: vw(30);
      margin-right: vw(30);
      color: #333333;
      font-size: vw(36);
    }
    .price-box {
      margin-left: vw(30);
      margin-right: vw(30);
      margin-top: vw(20);
      display: flex;
      flex-direction: row;
      align-items: center;
      .topPrice {
        color: #ff1414;
        font-size: vw(25);
        span {
          font-size: vw(30);
        }
        :last-child {
          font-size: vw(20);
        }
      }
      .remark {
        margin-left: vw(30);
        background-color: red;
        padding: vw(3) vw(10);
        color: #fff;
        font-size: vw(20);
        border-radius: vw(5);
      }
    }
  }
  .centerInfo {
    margin-top: vw(20);
    background-color: #ffffff;
    padding-bottom: vw(5);
    padding-top: vw(20);

    .type_box {
      overflow-x: hidden;
      margin-bottom: vw(20);
      margin-left: vw(30);
      margin-right: vw(30);
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .types {
        display: flex;
        flex-direction: row;
        align-items: center;
        .typeLabel {
          font-size: vw(28);
          min-width: vw(58);
          color: #999999;
          flex: 1;
        }
        .typeValue {
          margin-left: vw(40);
          font-size: vw(28);
          color: #333333;
          word-break: break-all;
        }
      }
    }
    .isSelfProvider-box {
      margin-left: vw(30);
      margin-right: vw(30);
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      .typeLabel {
        font-size: vw(28);
        color: #999999;
      }
      .isSelfProviderName {
        margin-left: vw(40);
        font-size: vw(28);
        color: #666666;
      }
      .isSelfProviderAddress {
        margin-left: vw(30);
        flex: 1;
        font-size: vw(26);
        color: #666666;
      }
    }
    .type_box_1 {
      margin-bottom: vw(20);
      margin-left: vw(30);
      margin-right: vw(30);
      display: flex;
      flex-direction: row;
      align-items: center;

      .typeLabel {
        font-size: vw(28);
        color: #999999;
      }
      .typeValue {
        margin-left: vw(40);
        font-size: vw(28);
        color: #333333;
      }
    }
  }

  .construct {
    margin-left: vw(30);
    margin-right: vw(30);
    font-size: vw(25);
    color: #666666;
  }
  .whiteSpace {
    width: 100%;
    height: vw(150);
  }
  .bottom_buttons {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: vw(80);
    background-color: #fff;
    display: flex;
    flex-direction: row;
    align-items: center;
    .sharePrice {
      flex: 1;
      font-size: vw(35);
      color: #ff1414;
      text-align: center;
      span {
        font-size: vw(25);
      }
    }
    .addCart {
      flex: 1;
      height: 100%;
      line-height: vw(80);
      text-align: center;
      border-top-left-radius: vw(8);
      border-bottom-left-radius: vw(8);
      background-color: #ff8000;
      color: #fff;
      font-size: vw(27);
      font-weight: bold;
    }
    .placeOrder {
      flex: 1;
      height: 100%;
      line-height: vw(80);
      text-align: center;
      border-top-right-radius: vw(8);
      border-bottom-right-radius: vw(8);
      background-color: #ff1414;
      color: #fff;
      font-size: vw(27);
      font-weight: bold;
    }
  }

  .content_box {
    padding-bottom: vw(200);
    .content_top {
      margin-top: vw(50);
      display: flex;
      flex-direction: row;
      align-items: center;
      .content_img {
        margin-left: vw(30);
        width: vw(120);
        height: vw(120);
        border-radius: vw(8);
      }
      .name_price {
        margin-left: vw(30);
        margin-right: vw(80);
        flex: 1;
        // height: vw(120);
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .productName {
          font-size: vw(30);
          color: #333333;
          font-weight: bold;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .content_price {
          font-size: vw(24);
          color: #ff1414;
          span {
            font-size: vw(36);
          }
        }
      }
    }
    .contentTypeText {
      margin-top: vw(30);
      margin-left: vw(30);
      font-size: vw(26);
      color: #666666;
    }
    .content_body {
      // height: 180px;
      // overflow-y: scroll;
      .contentTypeBox {
        margin-top: vw(25);
        margin-left: vw(30);
        margin-right: vw(30);
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-content: flex-end;
        align-items: center;
        .contentTypeItem {
          margin-top: vw(15);
          margin-left: vw(25);
          padding-left: vw(26);
          padding-right: vw(26);
          max-width: vw(650);
          box-sizing: border-box;
          height: vw(60);
          line-height: vw(60);
          border-radius: vw(30);
          font-size: vw(26);
          color: #666666;
          background-color: rgba($color: #f7f7f7, $alpha: 1);
          border: 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .activeGoods {
          border: vw(1) #ff1414 solid;
          color: #fff;
          background-color: #ff1414;
        }
      }

      .contentNums {
        margin-top: vw(60);
        margin-left: vw(30);
        margin-right: vw(30);
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        .numsLeft {
          display: flex;
          flex-direction: row;
          align-items: center;
          .numText {
            color: #333333;
            font-size: vw(28);
          }
          .leftNum {
            margin-left: vw(30);
            font-size: vw(25);
            color: #666666;
          }
        }
        .nums_box {
          display: flex;
          flex-direction: row;
          align-items: center;
          .nums_reduce {
            margin-left: vw(20);
            width: vw(35);
            height: vw(35);
          }
          .nums_num {
            margin-left: vw(20);
            font-size: vw(26);
            color: #333333;
          }
        }
      }
    }
    .buttons {
      position: fixed;
      bottom: vw(40);
      left: 0;
      right: 0;
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      align-items: center;
      .addshippingCart {
        color: #ffffff;
        font-size: vw(28);
        height: vw(80);
        border-radius: vw(8);
        background-image: linear-gradient(to right, #ffbb33, #ff9000);
        line-height: vw(80);
        width: 40%;
        text-align: center;
      }
      .toBuy {
        color: #ffffff;
        font-size: vw(28);
        height: vw(80);
        border-radius: vw(8);
        width: 40%;
        text-align: center;
        background-image: linear-gradient(to right, #ff8433, #ff3530);
        line-height: vw(80);
      }
    }
  }
  .coupons-text {
    background-color: #fff1e2;
    color: #ff8000;
    font-size: 13px;
    padding: 3px 8px;
    margin-left: 4px;
    border-radius: 2px;
  }

  .product-poster {
    position: fixed;
    top: 8%;
    left: 20px;
    right: 20px;
    z-index: 100;
  }

  .active-product-box {
    background-color: white;
    .active-product-item {
      margin-left: vw(30);
      margin-right: vw(30);
      background-color: #f4f6f9;
      border-radius: vw(10);
      padding-top: vw(20);
      padding-bottom: vw(20);
      .active-product-item-cell {
        padding: vw(10) vw(30);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        font-size: vw(26);
        .active-product-name-box {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          .active-product-name {
            color: #333333;
          }
          .orderBtn {
            padding-left: vw(10);
            padding-right: vw(10);
            padding-top: vw(6);
            padding-bottom: vw(6);
            color: #ffffff;
            border-radius: vw(5);
            background: linear-gradient(to right, #ff8d33, #ff3030);
          }
        }
        .active-product-price-box {
          margin-top: vw(15);
          display: flex;
          flex-direction: row;
          align-items: center;
          .active-product-active-price {
            color: #333333;
          }
        }
      }
    }
  }
  .add-paycar {
    box-sizing: border-box;
    width: 50px;
    height: 50px;
    position: fixed;
    bottom: 70px;
    right: 15px;
    background-image: linear-gradient(to right, #ff8433, #ff3530);
    border-radius: 25px;
    padding: 10px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.poster_wrapper_box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: vw(40);
    .block_box {
      width: vw(650);
      // height: vw(959);
      // overflow: hidden;
      // border-radius: vw(12);
    }
  }
</style>
